import React from "react";
import Loading from "../models/Loading"

class ShowProgress extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        token:window.sessionStorage["token"],
      };
    }
  
    componentWillUnmount() {
        document.body.style.overflow = 'unset';
    }
    async componentWillMount() {
      //for Dynamic Token
      this.setState({token:window.sessionStorage["token"]})
      this.setState({channel:window.sessionStorage["channel"]})
     
    }
  
    async componentDidMount(){
      document.body.style.overflow = 'hidden';
      this.setState({token:window.sessionStorage["token"]})
      this.setState({channel:window.sessionStorage["channel"]})
    }
  
    render() {
      return (
        <div className="flex items-center flex-column" >
            <Loading></Loading>  
            <span className="white fw3 f6">Please Wait..</span>       

  {/* )} */}
  </div>
       
      );
    }
  }
  export default ShowProgress;
  